/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Statep21Inputs */



/**
* | output |
* | --- |
* | "Right/bottom pump state" |
*
* @param {Ahu_History_Key_Statep21Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_statep21 = /** @type {((inputs?: Ahu_History_Key_Statep21Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Statep21Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Right/bottom pump state")
	return /** @type {LocalizedString} */ ("État pompe droite/basse")
});
export { ahu_history_key_statep21 as "ahu_history_key_stateP2" }